import {Text} from '@/components/ui/text/Text'
import styled, {css} from 'styled-components'

export const StyledGroupText = styled(Text)<{$isSelected: boolean}>(
    ({theme, $isSelected}) => css`
        display: block;
        color: ${theme.palette.neutral[$isSelected ? '400' : '500']};
    `
)
